import React from 'react';
import style from './quoteFlightDetails.module.scss';
import { FlightDetailsLegTable } from 'acscp/components/legs/flightDetailsLegTable';
import { Quote } from 'acscp/store';
import {QuoteDetails} from './quoteDetails';
import { FlightDetailsTripTable } from 'acscp/components/legs/flightPlan/flightDetailsTripTable';
import { QuoteButtons } from 'acscp/components/quotes/quoteButtons';
import classNames from 'classnames';
import { Department } from 'acscp/api/models/customTypes/department';
import { QuoteType } from 'acscp/api/models/customTypes/quoteType';

const QuoteFlightDetails: React.FC<{
    quote: Quote,
    userIsLoggedIn: boolean,
    onShowImageGallery: () => void,
    onShowFloorplan: () => void,
    jetCardHolder: boolean,
    jetCardType: string | null,
    disabled?: boolean
}> = ({ quote, userIsLoggedIn, onShowImageGallery, onShowFloorplan, jetCardHolder, jetCardType, disabled }) => {
        const { quoteType } = quote;
        const showAcceptButton = ENABLE_CREATE_ACCOUNT || (userIsLoggedIn && quote.department === Department.PJETS);
        const showPrice = !showAcceptButton && quote.sellPrice !== null;
        return (
            <div className={style.QuoteFlightDetails}>
                {quoteType === QuoteType.Series
                    ?
                    <>
                        <FlightDetailsTripTable
                            hasLowerBorder={true}
                            quote={quote}
                            amexNote={quote.isAmex && !quote.sellPrice ? quote.amexPriceNote : null}
                        />
                        <div
                            className={style.DisplayRight}
                        >
                            <QuoteButtons
                                className={classNames(style.ButtonGroup, !showPrice && style.ButtonRight)}
                                quote={quote}
                                jetCardHolder={jetCardHolder}
                                showAcceptButton={showAcceptButton}
                                disabled={disabled}
                            />
                        </div>
                    </>
                    :
                    <>
                        {quoteType !== QuoteType.ACMI &&
                            <FlightDetailsLegTable
                                legs={quote.legs}
                                className={style.LegsTable}
                                hasLowerBorder={true}
                                departmentKey={quote.department}
                                quoteType={quoteType}
                            />
                        }
                        {quoteType !== QuoteType.OBC && (
                            <QuoteDetails
                                quote={quote}
                                userIsLoggedIn={userIsLoggedIn}
                                onShowImageGallery={onShowImageGallery}
                                onShowFloorplan={onShowFloorplan}
                                jetCardHolder={jetCardHolder}
                                jetCardType={jetCardType}
                                disabled={disabled}
                            />
                        )}
                    </>
                }
            </div>
        );
    };

export { QuoteFlightDetails };
